import { render, staticRenderFns } from "./detail-tables.vue?vue&type=template&id=d53029ce&scoped=true&"
import script from "./detail-tables.vue?vue&type=script&lang=js&"
export * from "./detail-tables.vue?vue&type=script&lang=js&"
import style0 from "./detail-tables.vue?vue&type=style&index=0&id=d53029ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53029ce",
  null
  
)

export default component.exports